import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '56px',
    display: 'flex',
    borderRadius: '4px',
  },
  chip: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ` 0 ${theme.spacing(6)}px`,
    color: theme.palette.text.primary,
    fontSize: theme.typography.fontSize,
    lineHeight: '24px',
    fontWeight: 400,
    borderBottom: `2px solid ${theme.palette.background.default}`,
    '&.active': {
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    '&.active, &:hover': {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
    },
  },
}));
